import { OrderLookupSearch, OrdersSearch } from "../types";

export const urls = {
  orders: () => "/api/client/v1/orders/list/",
  order: (id: number) => `/api/client/v1/orders/${id}/`,
  orderPayment: (orderId: number) => `/api/client/v1/orders/${orderId}/payment/`,
  orderCancel: (orderId: number) => `/api/client/v1/orders/${orderId}/cancel/`,
  orderLookup: () => "/api/client/v1/orders/lookup/",
  orderModifications: (orderId: number) => `/api/client/v1/orders/${orderId}/modifications/`,
};

export const keys = {
  all: () => ["orders-all"],
  // orders
  orders: () => [...keys.all(), "orders"],
  orderLists: () => [...keys.orders(), "list"],
  orderList: (search: OrdersSearch) => [...keys.orderLists(), search],
  orderDetails: () => [...keys.orders(), "detail"],
  orderDetail: (id: number) => [...keys.orderDetails(), id],
  orderLookupDetail: (search: OrderLookupSearch) => [...keys.orderDetails(), search],
  orderModifications: () => [...keys.orders(), "modifications"],
  orderModificationDetail: (orderId: number) => [...keys.orderModifications(), "detail", orderId],
};
